/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Button, Link } from "@material-ui/core";
import { Publish } from "@material-ui/icons";
import { useDropzone } from "react-dropzone";
import "dropzone/dist/min/dropzone.min.css";
import "react-dropzone-component/styles/filepicker.css";

const SimpleFileButton = ({
  onChange,
  name,
  value,
  accept = "*",
  message = "Upload file",
  containerClass = "",
}) => {
  const { getInputProps } = useDropzone({
    accept,
    multiple: false,
    onDrop: (acceptedFiles, files) =>
      onChange({
        target: { name, value: acceptedFiles[0] ?? files[0]?.file ?? null },
      }),
  });

  const deleteFile = () => onChange({ target: { name, value: null } });

  return (
    <section
      id="kt_dropzone_1"
      className={`d-flex flex-column align-items-center ${containerClass}`}
    >
      <Button
        id={`upload_file_${name}_btn`}
        className="mb-2 mb-sm-0"
        variant="contained"
        color="secondary"
        startIcon={<Publish />}
      >
        <input
          id="files_drop_zone"
          {...getInputProps()}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            opacity: 0,
          }}
        />
        {message}
      </Button>
      {/* Existing uploaded file: show a friendly label + an explicit Remove
          action instead of the raw (truncated) S3 URL, which read like a link
          but actually deleted the file. */}
      {typeof value === "string" && value !== "" && (
        <span className="mt-2 d-inline-flex align-items-center text-muted">
          <span className="mr-2">Current file</span>
          <Link component="button" type="button" onClick={deleteFile}>
            Remove
          </Link>
        </span>
      )}
      {value?.name && (
        <span className="mt-2 d-inline-flex align-items-center text-muted">
          <span
            className="mr-2 text-truncate"
            style={{ maxWidth: 240 }}
            title={value.name}
          >
            {value.name}
          </span>
          <Link component="button" type="button" onClick={deleteFile}>
            Remove
          </Link>
        </span>
      )}
    </section>
  );
};

export default SimpleFileButton;
